module.exports = __webpack_public_path__ + "img/pic_5.8cb31592.jpg";